// extracted by mini-css-extract-plugin
module.exports = {"amountForm":"styles_amountForm__3s72m"};